import React from 'react'
import { Redirect } from 'react-router-dom'

function Login() {
  return <Redirect to='/' />
}

export default Login
